import { useEffect, useState } from "react";
import {
  FormGroup,
  FormLabel,
  IconButton,
  TextField,
  Tooltip,
} from "@material-ui/core";
import {
  DatePicker,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { FiltroRepPlano2DTO } from "../../models/controlls.model";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { fil } from "date-fns/locale";

export default function CalendarC(props: calendarProps) {
  const [inicio, setInicio] = useState<string | null>(
    props.previousValue.length > 0
    ? props.previousValue[0]
    : props.values
    ? props.values[0]
    : null
  );
  const [fin, setFin] = useState<string | null>(
    props.previousValue.length > 0
    ? props.previousValue[1]
    : props.values
    ? props.values[1]
    : null
  );
  const [validaInicio, setValidaInicio] = useState<boolean>(false);
  const [validaFin, setValidaFin] = useState<boolean>(true);
  const [messageInicio, setMessageInicio] = useState<string>("");
  const [messageFin, setMessageFin] = useState<string>("");

  const campo = props.id.split("-")[0];


  useEffect(() => {
    props.guardaSeleccion(campo ,  creaFiltro());

    if (Object.keys(props.filtros).length === 0) return;

    props.filtros[campo].valor = [inicio ?? "", fin ?? ""];
    props.filtros[campo].nombreColumna = props.nombreColumna;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inicio, fin]);

  useEffect(() => {
    setMessageFin(validaFin ? "Formato de fecha invalido" : "");
  }, [validaFin]);
  useEffect(() => {
    if (["", null].includes(fin)) {
      setValidaFin(false);
      return;
    }

    let valida = Date.parse(fin ?? "");
    setValidaFin(isNaN(valida));
  }, [fin]);

  useEffect(() => {
    setMessageInicio(validaInicio ? "Formato de fecha invalido" : "");
  }, [validaInicio]);
  useEffect(() => {
    if (["", null].includes(inicio)) {
      setValidaInicio(false);
      return;
    }

    let valida = Date.parse(inicio ?? "");
    setValidaInicio(isNaN(valida));
  }, [inicio]);

  function creaFiltro(): FiltroRepPlano2DTO {
    return {
      campo: campo,
      valor: [inicio ?? "", fin ?? ""],
      operador: "",
      filtro: props.filtro,
      nombreColumna: props.nombreColumna,
    };
  }

  const handleClickIco = (event: React.MouseEvent<HTMLButtonElement>) => {
    props.eliminaInput(props.id, props.filtro);
  };

  return (
    <>
      {props.onlyMonth ? (
        <div style={{ margin: "0 1%" }}>
          <FormLabel>
            {campo}
            {props.opciones ? (
              <Tooltip title="elimina campo">
                <IconButton
                  id={`ico-${campo}`}
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={handleClickIco}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            ) : null}
          </FormLabel>
          <FormGroup row>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
              <KeyboardDatePicker
                label="Mes"
                variant="inline"
                format="MM"
                margin="normal"
                views={["month"]}
                value={inicio}
                onChange={(
                  date: MaterialUiPickersDate,
                  value?: string | null | undefined
                ) => {
                  setFin(value ?? "");
                  setInicio(value ?? "");
                }}
                style={{ width: "98%", marginRight: "4%" }}
                invalidDateMessage=""
              />
            </MuiPickersUtilsProvider>
          </FormGroup>
        </div>
      ) : (
        <div style={{ margin: "0 1%" }}>
          <FormLabel>
            {campo}
            {props.opciones ? (
              <Tooltip title="elimina campo">
                <IconButton
                  id={`ico-${campo}`}
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={handleClickIco}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            ) : null}
          </FormLabel>
          <FormGroup row>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
              <KeyboardDatePicker
                label="Inicio"
                variant="inline"
                format="yyyy/MM/dd"
                margin="normal"
                views={["year", "month", "date"]}
                minDate={new Date(props.años[0], 0, 1)}
                maxDate={new Date(props.años[1], 11, 31)}
                value={inicio}
                error={validaInicio}
                invalidDateMessage={messageInicio}
                onChange={(
                  date: MaterialUiPickersDate,
                  value?: string | null | undefined
                ) => {
                  if (fin === null || fin === undefined)
                    setFin(`${props.años[1]}/12/31`);
                  setInicio(value ?? "");
                }}
                style={{ width: "48%", marginRight: "4%" }}
              />
              <KeyboardDatePicker
                label="Fin"
                variant="inline"
                format="yyyy/MM/dd"
                margin="normal"
                views={["year", "month", "date"]}
                error={validaFin}
                invalidDateMessage={messageFin}
                minDate={new Date(props.años[0], 0, 1)}
                maxDate={new Date(props.años[1], 11, 31)}
                value={fin}
                onChange={(
                  date: MaterialUiPickersDate,
                  value?: string | null | undefined
                ) => {
                  if (inicio && date) {
                    let ini = inicio?.split("/");
                    let fInicio = new Date(
                      parseInt(ini[0]),
                      parseInt(ini[1]) - 1,
                      parseInt(ini[2])
                    );
                    if (fInicio > date) {
                      setFin(inicio);
                      return;
                    }
                  }
                  if (inicio === null || inicio === undefined)
                    setInicio(`${props.años[0]}/1/1`);
                  setFin(value ?? "");
                }}
                style={{ width: "48%" }}
              />
            </MuiPickersUtilsProvider>
          </FormGroup>
        </div>
      )}
    </>
  );
}

interface calendarProps {
  id: string;
  años: number[];
  filtro: boolean;
  filtros: any;
  opciones: boolean;
  nombreColumna: string;
  eliminaInput(idCampo: string, filtroInput: boolean): void;
  guardaSeleccion(campo: string, filtro: FiltroRepPlano2DTO): void;
  onlyMonth: boolean;
  values?: string[];
  specificLabel?: string;
  previousValue: any[];
}

CalendarC.defaultProps = {
  values: undefined,
  opciones: true,
  onlyMonth: false,
  nombreColumna: "",
  previousValue: []
};
